import React, { useEffect } from "react";
import { isMobile, isMobileOnly } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import axios from "axios";
import { base_url, postHeader } from "../../Helpers/request";
import { useState } from "react";
import { toast } from "react-toastify";
// import Banner from '../assets/images/dubai-banner.png'
// import '../../dubai/assets/css/dubai.css'
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom";

// Custom arrow components
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", left: "20px", zIndex: 1 }}
      onClick={onClick}
    >
      <FaChevronLeft size={24} color="#fff" />
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", right: "20px", zIndex: 1 }}
      onClick={onClick}
    >
      <FaChevronRight size={24} color="#fff" />
    </div>
  );
};

const BannerSlider = () => {
  const history = useHistory();
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //-----------------------------------Banner
    setLoading(true);
    axios
      .get(base_url + `/home/slider`, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setLoading(false);
          setBanner(response.data.data);
          localStorage.setItem(
            "bw-bannerdata",
            JSON.stringify(response.data.data)
          );
        } else {
          toast.error(response.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const settingBanner = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };


  return (
    <>
    {console.log(banner)}
      <Slider {...settingBanner} className="dubai_banner_slider">
        {
          banner?.map((val, index) => (
            <div
              className="rcs_hero_slider du_main_banner_section"
            >
              <div className="rcs_hero_img">
                <Link to={val.btn_link}>
                  <Image src={isMobileOnly ? val.mobile_image : val.image} alt="" fluid />
                </Link>
                <Container className="dubai-showcase-container">
                  <Row className="m-auto w-100">
                    <Col md={6} xs={12} className="d-flex justify-content-center" >
                      {val.btn_text === "" ? (
                        ""
                      ) : (
                        <div
                          className={`${
                            isMobile ? "text-center" : val.text_direction_class
                          } text-center`}
                        >
                          <h1 data-aos="fade-up-left" data-aos-duration="700">
                            {val.title + " " + "Dubai" }
                          </h1>
                          <p
                            data-aos="fade-up-left"
                            data-aos-duration="1200"
                            data-aos-delay="300"
                          >
                            {val.short_text}
                          </p>
                          <button
                            data-aos="fade-up-left"
                            data-aos-duration="1800"
                            data-aos-delay="400"
                            onClick={() => {
                              history.push("/" + val.btn_link);
                            }}
                            className="btn_white"
                          >
                            {val.btn_text}
                          </button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          ))
        }

      </Slider>
      {/* {!loading ? (
        banner?.map((val, index) => (
          <div
            className="rcs_hero_slider du_main_banner_section"
            style={{
              backgroundImage: `url(${
                isMobileOnly ? val?.mobile_image : val?.image
                isMobileOnly ? Banner : Banner
                
              })`,
            }}
          >
            <div className="rcs_hero_img">
              <Container className="dubai-showcase-container">
                <Row className="m-auto w-100">
                  <Col md={6} xs={12} className="d-flex justify-content-center" > */}
      {/* {val.btn_text === "" ? (
                      ""
                    ) : (
                      <div
                        className={`${
                          isMobile ? "text-center" : val.text_direction_class
                        } text-center`}
                      >
                        <h1 data-aos="fade-up-left" data-aos-duration="700">
                          {val.title + " " + "Dubai" }
                        </h1>
                        <p
                          data-aos="fade-up-left"
                          data-aos-duration="1200"
                          data-aos-delay="300"
                        >
                          {val.short_text}
                        </p>
                        <button
                          data-aos="fade-up-left"
                          data-aos-duration="1800"
                          data-aos-delay="400"
                          onClick={() => {
                            history.push("/" + val.btn_link);
                          }}
                          className="btn_white"
                        >
                          {val.btn_text}
                        </button>
                      </div>
                    )} */}


      {/* </Col>
                </Row>
              </Container>
            </div>
          </div>
        ))
      ) : (
        <div className="sk" style={{ margin: "0px" }}>
          <Skeleton variant="text" animation="wave" height={"90vh"} />
        </div>
      )} */}
    </>
  );
};

export default BannerSlider;
